import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bbb5aea8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bbb5aea8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb5aea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbb5aea8')) {
      api.createRecord('bbb5aea8', component.options)
    } else {
      api.reload('bbb5aea8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bbb5aea8&scoped=true", function () {
      api.rerender('bbb5aea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cpscc/viewHtml/index.vue"
export default component.exports